import { LoadingSpinner, TableCellId } from "@bluefalcon/components-package";
import { Tenant, TenantCreateRequest, TenantUpdateRequest } from "@bluefalcon/users-management-client-fetch";
import { Box, Button, Flex, Input, Table, TableCaption, Tbody, Td, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { tenantsService } from "../../services";
import { AddEditTenantModal } from "../../modals/add-edit-tenant.modal";
import { Link } from "react-router-dom";

type TenantsTableProps = {};

export const TenantsTable = ({ }: TenantsTableProps) => {

    const [tenants, setTenants] = useState<Tenant[]>([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedTenant, setSelectedTenant] = useState<Tenant>();
    const [query, setQuery] = useState('');

    const fetchTenants = async () => {
        setIsLoading(true);
        try {
            const { results, total: _total } = await tenantsService.searchTenants({
                query,
            });
            setTenants(results);
            setTotal(_total);
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    };

    const onCreateTenant = async (req: TenantCreateRequest) => {
        await tenantsService.createTenant(req);
        fetchTenants();
        onClose();
    };

    const onUpdateTenant = async (id: string, req: TenantUpdateRequest) => {
        await tenantsService.updateTenantById(id, req);
        fetchTenants();
        onClose();
    };

    const onAddButtonClick = () => {
        setSelectedTenant(undefined);
        onOpen();
    };

    const handleEditButtonClick = (tenant: Tenant) => {
        setSelectedTenant(tenant);
        onOpen();
    };

    const search = async () => {
        await fetchTenants();
    };

    useEffect(() => {
        fetchTenants();
    }, []);


    if (isLoading) {
        return <LoadingSpinner />
    }

    return (
        <>
            <Flex mb={2}>
                <form onSubmit={search}>
                    <Flex>
                        <Input onChange={(e) => setQuery(e.target.value)} value={query} placeholder="search..." type={'search'} />
                        <Button type="submit" onClick={search} ml={2} colorScheme="primary">Search</Button>
                    </Flex>
                </form>
                <Button onClick={onAddButtonClick} ml={'auto'} colorScheme="teal">Add Tenant</Button>
            </Flex>
            {tenants.length ? <Table variant="simple">
                <TableCaption textAlign={'left'}>Total Tenants: {total}</TableCaption>
                <Thead>
                    <Tr>
                        <Th>ID</Th>
                        <Th>Name</Th>
                        <Th>Email</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {tenants.map(tenant => (
                        <Tr key={tenant.id}>
                            <Td><TableCellId label={tenant.id} route={`/tenants/${tenant.id}`} /></Td>
                            <Td>{tenant.name}</Td>
                            <Td>{tenant.email}</Td>
                            <Td>
                                <Flex>
                                    <Button mr={2} size="sm" onClick={() => handleEditButtonClick(tenant)}>
                                        Edit
                                    </Button>
                                    <Button as={Link} to={`/tenants/${tenant.id}`} mr={2} size="sm">
                                        Details
                                    </Button>
                                </Flex>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table> : <Box textAlign={'center'} mt={5}>
                No tenants found.
            </Box>}
            <AddEditTenantModal
                onClose={onClose}
                isOpen={isOpen}
                tenant={selectedTenant}
                handleAddTenant={onCreateTenant}
                handleEditTenant={onUpdateTenant}
            />
        </>
    )
};
